import { uuid } from "@/lib/types";

/**
 * A business unit filter value, scoped to its tenant.
 * This is required because, ServiceTitan business unit ids are only unique within a ServiceTitan tenant,
 * but they can collide across tenants so a bare id
 * cannot identify a business unit in All Tenants view.
 */
export interface BusinessUnitSelection {
  tenantId: uuid;
  businessUnitId: number;
}

const SEPARATOR = "::";

export function formatBusinessUnitSelection({
  tenantId,
  businessUnitId,
}: BusinessUnitSelection): string {
  return `${tenantId}${SEPARATOR}${businessUnitId}`;
}

export function parseBusinessUnitSelections(values: string[]): BusinessUnitSelection[] {
  return values.map(value => {
    const [tenantId, businessUnitId] = value.split(SEPARATOR);
    return { tenantId, businessUnitId: Number(businessUnitId) };
  });
}

export function groupBusinessUnitSelectionsByTenant(
  selections: BusinessUnitSelection[]
): Map<uuid, number[]> {
  const byTenant = new Map<uuid, number[]>();
  for (const { tenantId, businessUnitId } of selections) {
    const ids = byTenant.get(tenantId);
    if (ids) {
      ids.push(businessUnitId);
    } else {
      byTenant.set(tenantId, [businessUnitId]);
    }
  }
  return byTenant;
}
